var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _linearGradient26, _linearGradient27, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDivingHelmet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#537983"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3e5959"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg1",
    y1: 421.981,
    y2: 504.537
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3e5959",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#384949"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 294.106,
    x2: 286.773,
    xlinkHref: "#lg2",
    y1: 523.503,
    y2: 423.503
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg2",
    y1: 474.667,
    y2: 506.729
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fe9738"
  }))), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 138.722,
    x2: 404.113,
    xlinkHref: "#lg3",
    y1: 151.664,
    y2: 417.055
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe9738",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fe7701"
  }))), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 177.734,
    x2: 0.401,
    xlinkHref: "#lg4",
    y1: 303.859,
    y2: 209.192
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 297.345,
    x2: 297.345,
    xlinkHref: "#lg4",
    y1: 94,
    y2: -15.335
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 396.969,
    x2: 262.969,
    xlinkHref: "#lg4",
    y1: 330.549,
    y2: 197.882
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg5"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#edf5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c7e9ff"
  }))), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 251.373,
    x2: 260.039,
    xlinkHref: "#lg5",
    y1: 11.237,
    y2: 47.237
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 67.711,
    x2: 121.794,
    xlinkHref: "#lg5",
    y1: 159.465,
    y2: 213.549
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 383.299,
    x2: 425.305,
    xlinkHref: "#lg5",
    y1: 157.878,
    y2: 199.884
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 196.611,
    x2: 329.815,
    xlinkHref: "#lg5",
    y1: 129.777,
    y2: 262.982
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientTransform: "matrix(-1 0 0 -1 -554 -554)",
    gradientUnits: "userSpaceOnUse",
    x1: -858.416,
    x2: -745.684,
    xlinkHref: "#lg5",
    y1: -791.582,
    y2: -678.85
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 228.5,
    x2: 293.876,
    xlinkHref: "#lg1",
    y1: 161.667,
    y2: 227.043
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg3",
    y1: 430.667,
    y2: 470.672
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 27.674,
    x2: 68.696,
    xlinkHref: "#lg5",
    y1: 71.207,
    y2: 112.228
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 42.467,
    x2: 60.7,
    xlinkHref: "#lg5",
    y1: 122.891,
    y2: 141.124
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 67.154,
    x2: 85.387,
    xlinkHref: "#lg5",
    y1: 26.633,
    y2: 44.866
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 127.309,
    x2: 127.309,
    xlinkHref: "#lg3",
    y1: 413,
    y2: 389.515
  })), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 190.655,
    x2: 190.655,
    xlinkHref: "#lg3",
    y1: 425,
    y2: 401.515
  })), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg3",
    y1: 434,
    y2: 410.515
  })), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 319.345,
    x2: 319.345,
    xlinkHref: "#lg3",
    y1: 425,
    y2: 401.515
  })), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 382.691,
    x2: 382.691,
    xlinkHref: "#lg3",
    y1: 413,
    y2: 389.515
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m488.195 510h-466.39c-6.287 0-11.383-5.096-11.383-11.383 0-60.729 49.231-109.96 109.96-109.96h269.236c60.729 0 109.96 49.231 109.96 109.96 0 6.287-5.096 11.383-11.383 11.383z",
    fill: "url(#SVGID_1_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m389.618 388.657h-269.236c-14.659 0-28.644 2.876-41.433 8.082v23.671l89.59 89.59h319.656c6.287 0 11.383-5.096 11.383-11.383 0-60.729-49.231-109.96-109.96-109.96z",
    fill: "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.422 498.617c0 6.287 5.096 11.383 11.383 11.383h466.391c6.287 0 11.383-5.096 11.383-11.383 0-17.722-4.199-34.462-11.646-49.289h-465.865c-7.447 14.827-11.646 31.567-11.646 49.289z",
    fill: "url(#SVGID_3_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m418.512 378.078c-30.859-10.098-46.93-44.36-34.361-74.297 1.636-3.898 3.426-7.216 5.379-9.692 22.98-29.141 36.694-65.928 36.694-105.922 0-95.727-78.556-173.106-174.719-171.188-92.744 1.848-167.567 78.122-167.728 170.883-.07 40.107 13.653 77.004 36.687 106.217 1.954 2.478 3.745 5.8 5.382 9.701 12.566 29.939-3.502 64.199-34.361 74.298-12.427 4.067-19.656 8.928-19.656 14.584 0 40.266 82.008 72.909 183.171 72.909s183.171-32.642 183.171-72.909c0-5.655-7.231-10.517-19.659-14.584z",
    fill: "url(#SVGID_4_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m428.15 416.495-318.538-318.538c-16.316 26.171-25.778 56.998-25.836 89.906-.07 40.107 13.653 77.004 36.687 106.217 1.954 2.478 3.745 5.8 5.383 9.701 12.566 29.939-3.502 64.199-34.361 74.298-12.427 4.067-19.656 8.928-19.656 14.584 0 40.266 82.008 72.909 183.171 72.909 80.194 0 148.341-20.515 173.15-49.077z",
    fill: "url(#SVGID_5_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m251.504 16.978c-30.241.603-58.574 9.124-83.037 23.544l234.254 234.254c14.933-25.409 23.502-55.006 23.502-86.609 0-95.727-78.556-173.106-174.719-171.189z",
    fill: "url(#SVGID_6_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m389.529 294.088c20.938-26.552 34.179-59.452 36.367-95.34l-83.031-83.031c-20.9-23.106-51.117-37.625-84.726-37.625-63.079 0-114.214 51.135-114.214 114.214 0 33.61 14.519 63.826 37.625 84.726l176.04 176.039c48.623-13.108 80.581-35.272 80.581-60.408 0-5.656-7.23-10.518-19.659-14.585-30.859-10.098-46.93-44.36-34.361-74.297 1.636-3.898 3.426-7.217 5.378-9.693z",
    fill: "url(#SVGID_7_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m334.335 42.317h-158.67c-8.457 0-15.313-6.856-15.313-15.313 0-14.914 12.09-27.004 27.004-27.004h135.288c14.914 0 27.004 12.09 27.004 27.004 0 8.458-6.855 15.313-15.313 15.313z",
    fill: "url(#SVGID_8_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m114.147 108.831v158.671c0 8.457-6.856 15.313-15.313 15.313-14.914 0-27.004-12.09-27.004-27.004v-135.288c0-14.914 12.09-27.004 27.004-27.004 8.457-.001 15.313 6.855 15.313 15.312z",
    fill: "url(#SVGID_9_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m395.853 108.831v158.671c0 8.457 6.856 15.313 15.313 15.313 14.914 0 27.004-12.09 27.004-27.004v-135.288c0-14.914-12.09-27.004-27.004-27.004-8.457-.001-15.313 6.855-15.313 15.312z",
    fill: "url(#SVGID_10_)"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 255,
    cy: 188.167,
    fill: "url(#SVGID_11_)",
    r: 114.214
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 255,
    cy: 188.167,
    fill: "url(#SVGID_12_)",
    r: 96.66
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 255,
    cy: 188.167,
    fill: "url(#SVGID_13_)",
    r: 80.761
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m445.06 390.82c-1.449-4.838-7.778-6.093-11.266-2.44-26.672 27.926-96.654 47.858-178.795 47.858s-152.122-19.932-178.794-47.858c-3.488-3.652-9.817-2.397-11.266 2.44-.181.605-.273 1.219-.273 1.843 0 40.266 85.215 72.909 190.333 72.909s190.333-32.642 190.333-72.909c.001-.624-.091-1.238-.272-1.843z",
    fill: "url(#SVGID_14_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 39.704,
    cy: 83.236,
    fill: "url(#SVGID_15_)",
    r: 29.283
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.011,
    cy: 132.435,
    fill: "url(#SVGID_16_)",
    r: 16.976
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.698,
    cy: 36.177,
    fill: "url(#SVGID_17_)",
    r: 16.976
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 127.309,
    cy: 392.586,
    fill: "url(#SVGID_18_)",
    r: 14.333
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 190.655,
    cy: 404.586,
    fill: "url(#SVGID_19_)",
    r: 14.333
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 255,
    cy: 413.586,
    fill: "url(#SVGID_20_)",
    r: 14.333
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 319.345,
    cy: 404.586,
    fill: "url(#SVGID_21_)",
    r: 14.333
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 382.691,
    cy: 392.586,
    fill: "url(#SVGID_22_)",
    r: 14.333
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDivingHelmet);
export default __webpack_public_path__ + "static/media/icon-diving-helmet.7b8a7814dd44a1aa908a7f62153437f5.svg";
export { ForwardRef as ReactComponent };